module.exports = __webpack_public_path__ + "img/tipocontacto010.48734e2.svg";